import { PaxTypeResponseBuilder } from './PaxTypeResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class BookingRequirementResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('BookingRequirement');
    }
    public withId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['id'] = this.initField(null, args);
        return this;
    }

    public withAdultRequired = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['adultRequired'] = this.initField(null, args);
        return this;
    }

    public withMinPax = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['minPax'] = this.initField(null, args);
        return this;
    }

    public withMaxPax = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['maxPax'] = this.initField(null, args);
        return this;
    }

    public withPaxTypes = (builder: PaxTypeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['paxTypes'] = this.initField(builder, args);
        return this;
    }

    public withPaxRequirementRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['paxRequirementRefId'] = this.initField(null, args);
        return this;
    }
}
